import { BASE_URL } from '@/utils/host'
import http from '@/utils/http'

const api_10067 = BASE_URL.WG + '/api/10067'
const api_10082 = BASE_URL.WG + '/api/10082'
const api_10020 = BASE_URL.WG + '/api/10020'
const api_40002 = BASE_URL.WG + '/api/40002'

export function getInfo(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/getById', data)
}

// 获取用户所有菜单数据
export function getMenuList(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/menu/getMenuByUserId', data)
}

// 退出登录
export function logout() {
  return http.post(BASE_URL.WG + '/api/10020/sso/logout')
}

// 获取用户信息
export function getLoginUser() {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/getLoginUser')
}

// 获取主公司logo
export function getMainBranchLogo() {
  return http.post(BASE_URL.WG + '/api/40002/rms/branch/Sigil/get_main_branch_logo')
}

// 查询版本到期时间
export function getTenantSummary() {
  return http.post(api_10067 + '/tenant/getTenantSummary')
}

// 获取皮肤
export function getSkinJson(data) {
  return http.post(api_10067 + '/common/skin/get_skin_json', data)
}

// 多语言
export function getLanguageResource(data) {
  return http.post(api_10082 + '/language/resource/getLanguageResource', data)
}

//
export function toExternalSsoLogin(data) {
  return http.post(api_10020 + '/external/sso/login', data)
}
// 员工信息聚合查询
export function getUserList(data) {
  return http.post(api_40002 + '/rms/user/list', data)
}

// 员工详情
export function getById(data) {
  return http.post(api_40002 + '/rms/user/getById', data)
}

// 用户角色
export function getRoleByUser(data) {
  return http.post(api_40002 + '/rms/user/getRoleByUser', data)
}
// 解除角色关联
export function associatedRoleRemove(data) {
  return http.post(api_40002 + '/rms/user/associatedRoleRemove', data)
}
// 员工关联角色保存
export function associatedRoleAdd(data) {
  return http.post(api_40002 + '/rms/user/associatedRoleAdd', data)
}

// 员工菜单-权限查询
export function getMenuByUser(data) {
  return http.post(api_40002 + '/rms/user/getMenuByUser', data)
}
// 员工菜单-修改权限数据
export function userMenuUpdate(data) {
  return http.post(api_40002 + '/rms/user/userMenuUpdate', data)
}
// 员工菜单-修改权限数据保存
export function userMenuUpdateSave(data) {
  return http.post(api_40002 + '/rms/user/userMenuUpdateSave', data)
}

// 员工功能-菜单功能权限
export function getFunctionByUserAndMenu(data) {
  return http.post(api_40002 + '/rms/user/getFunctionByUserAndMenu', data)
}
// 员工功能-菜单功能权限修改数据
export function functionUserUpdate(data) {
  return http.post(api_40002 + '/rms/user/functionUserUpdate', data)
}
// 员工功能-菜单功能权限修改数据保存
export function functionUserUpdateSave(data) {
  return http.post(api_40002 + '/rms/user/functionUserUpdateSave', data)
}

// 员工数据权限-菜单数据权限
export function getDataAuthByUserAndMenu(data) {
  return http.post(api_40002 + '/rms/user/getDataAuthByUserAndMenu', data)
}
// 员工数据权限-菜单数据权限修改数据
export function dataAuthUserUpdate(data) {
  return http.post(api_40002 + '/rms/user/dataAuthUserUpdate', data)
}
// 员工数据权限-菜单数据权限修改保存
export function dataAuthUserUpdateSave(data) {
  return http.post(api_40002 + '/rms/user/dataAuthUserUpdateSave', data)
}

// 登录记录
export function getUserLoginLog(data) {
  return http.post(api_40002 + '/rms/user/getUserLoginLog', data)
}
// 交接列表
export function getHandoverList(data) {
  return http.post(api_40002 + '/rms/facade/user/handover/pageList', data)
}
// 新增编辑交接信息
export function insertOrUpdateHandOver(data) {
  return http.post(api_40002 + '/rms/facade/user/handover/insertOrUpdate', data)
}
// 交接详情
export function getHandOverDetail(data) {
  return http.post(api_40002 + '/rms/facade/user/handover/detail', data)
}
// 删除交接信息
export function deleteHandOver(data) {
  return http.post(api_40002 + '/rms/facade/user/handover/deleteById', data)
}
